module.exports = __webpack_public_path__ + "img/Vorschule.d27792c7.jpg";